<table class="w-100 text-sm border border-gray-200">
  <thead class="bg-gray-100 w-full">
    <tr>
      <th class="p-2 border text-center bg-light">{{ headerLabel }}</th>
      <th *ngFor="let col of columns" class="p-2 border bg-info-subtle">
        {{ col }}
      </th>
    </tr>
  </thead>
  <tbody class="w-full">
    <tr *ngFor="let row of rows">
      <th *ngIf="row.label !== ''" [attr.rowspan]="row.rowspan" class="p-2 border text-center bg-light align-middle">{{
        row.label }}</th>
      <td *ngFor="let val of row.values" class="p-2 border">{{ val }}</td>
    </tr>
  </tbody>
</table>